import React from "react";

const AgencySignup = () => {
  return <h1>NEW AGENCY</h1>;
};

export default AgencySignup;
